import React, { Component, Fragment } from 'react';

import _cloneDeep from 'lodash/cloneDeep';
import _compact from 'lodash/compact';
import _forEach from 'lodash/forEach';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _set from 'lodash/set';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Typeahead } from 'react-bootstrap-typeahead';

import InputGroup from 'react-bootstrap/InputGroup';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import TopicPicker from './TopicPicker';
import AddTokensBox from './AddTokensBox';
import DeviceTokensList from './targeting/DeviceTokensList';
import TopicTreeView, { isTopicValid } from './targeting/TopicTreeView';

import { CONSTANTS } from '../../utils/common';
import { withContext } from './NotificationContext';
import '../../styles/Notification.css';

const TARGET_TYPES = {
  all: {
    label: 'All Customers',
  },
  app: {
    label: 'App',
    placeholder: 'Please select apps',
  },
  topic: {
    label: 'Topic',
    placeholder: 'Pick topics',
  },
  device: {
    label: 'Device',
    placeholder: 'Device tokens',
  }
};

class Targeting extends Component {

  state = {
    showTopicPicker: false,
    showAddTokensBox: false
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    
    const targeting = _get(nextProps.context, 'currentMessage.targeting');
    const type = _get(targeting, 'targetType.label');

    if('App' === type) {
      return {selectedApps: _get(targeting, 'selected', null)};
    } else if('Device' === type) {
      return {selectedDevice: _get(targeting, 'selected', '')};
    } else {
      return null;
    }
  }

  handleAllChanged = () => {
    const {currentMessage, updateState} = this.props.context;
    currentMessage.targeting = {
      targetType: TARGET_TYPES['all'],
      isValid: true,
    };

    updateState({currentMessage});
  }

  handleAppChanged = selected => {
    if(!selected) {
      selected = this.state.selectedApps || ['iOS', 'Android', 'Web'];
    }

    const {currentMessage, updateState} = this.props.context;
    currentMessage.targeting = {
      targetType: TARGET_TYPES['app'],
      selected,
      options: ['iOS', 'Android', 'Web'],
      isValid: selected.length > 0,
    };

    updateState({currentMessage});
  }

  handleTopicChanged = () => {
    const { rootTopic } = this.props.context;
    const {currentMessage, updateState} = this.props.context;

    currentMessage.targeting = {
      targetType: TARGET_TYPES['topic'],
      selected: rootTopic.prune().children,
      isValid: isTopicValid(rootTopic.children),
    };
    updateState({currentMessage});
    this.setState({
      showTopicPicker: false,
    })
  }

  clearChildSelected = (topic) => {
    _forEach(topic.children, child => {
      _set(child, 'selected', false);
      
      if (_isEmpty(child.children === false)) {
        this.clearChildSelected(child);
      }
    });
  };

  findAndToggleOffTopicInList = (topicKey, selectedTopics) => {
    _forEach(selectedTopics, topic => {
      if (topic.key === topicKey) {
        _set(topic, 'selected', false);

        if (_isEmpty(topic.parent) === false) {
          _set(topic, 'parent.selected', false);
        }

        if (_isEmpty(topic.children) === false) {
          this.clearChildSelected(topic);
        }
      }

      if (_isEmpty(topic.children) === false) {
        this.findAndToggleOffTopicInList(topicKey, topic.children);
      }
    })
  }
  
  handleOnToggleOffTopic = (topicKey) => {
    const rootTopic = _cloneDeep(this.props.context.rootTopic);
    const currentSelectedItem = _get(rootTopic, 'children', []);

    if (_isEmpty(currentSelectedItem) === false) {
      this.findAndToggleOffTopicInList(topicKey, currentSelectedItem);
      const { currentMessage, updateState } = this.props.context;

      currentMessage.targeting = {
        ...currentMessage.targeting,
        selected: rootTopic.prune().children,
        isValid: isTopicValid(rootTopic.children),
      };

      updateState({rootTopic, currentMessage});
    }
  }

  handleDeviceChanged = async () => {
    const {currentMessage, setStateAsync, tokens} = this.props.context;

    const compacted = _compact(tokens);
    currentMessage.targeting = {
      targetType: TARGET_TYPES['device'],
      selected: tokens,
      // this is note from firebase: A non-empty array containing up to 100 device registration tokens.
      isValid: compacted.length > 0 && compacted.length <= CONSTANTS.max_token_num,
    };

    await setStateAsync({currentMessage});

    this.setState({
      showAddTokensBox: false,
    });
  };


  onHide = () => {
    this.setState({
      showTopicPicker: false,
    });
  }

  onHideAddTokensBox = () => {
    this.setState({
      showAddTokensBox: false,
    });
  }

  showTopicPicker = () => {
    this.setState({
      showTopicPicker: true,
    });
  }

  showAddTokensBox = () => {
    this.setState({
      showAddTokensBox: true,
    });
  }

  onDeleteToken = async (index, currentTokens) => {
   const {tokens} =  this.props.context;
   // in case we load compose notification the tokens get from context always = [], so we much assign variable 
   if( currentTokens.length !== tokens.length) {
    await this.props.context.setStateAsync({tokens: currentTokens});
    this._deleteToken(index);
   } else {
    this._deleteToken(index);
   }
  }
  _deleteToken(index) {
    const {deleteToken} =  this.props.context;
    deleteToken(index).then( () => {this.handleDeviceChanged()} );
  }
  render() {
    const {currentMessage} = this.props.context;

    const title = _get(currentMessage, 'targeting.targetType.label', 'Targeting');

    const style = {width: '70%'}
    return (
      <InputGroup>
        <DropdownButton
          as={InputGroup.Prepend}
          variant="outline-secondary"
          title={title}
          id="input-group-dropdown-targeting"
        >
          <Dropdown.Item onClick={() => this.handleAllChanged()}>All Customers</Dropdown.Item>
          <Dropdown.Item onClick={() => this.handleAppChanged()}>App</Dropdown.Item>
          <Dropdown.Item onClick={this.handleTopicChanged}>Topic</Dropdown.Item>
          <Dropdown.Item onClick={() => this.handleDeviceChanged()}>Device</Dropdown.Item>
        </DropdownButton>
        <InputGroup.Append style={style}>
          {this._renderTargetingPicker()}
        </InputGroup.Append>
        {this._getTopicPickerAndAddTokenBox()}
      </InputGroup>
    );
  }

  _getTopicPickerAndAddTokenBox() {
    if(this.state.showTopicPicker) {
      return <TopicPicker
        show={this.state.showTopicPicker}
        onHide={this.onHide}
        onDone={this.handleTopicChanged}
      />;
    }

    if(this.state.showAddTokensBox) {
      return <AddTokensBox
        show={this.state.showAddTokensBox}
        onHide={this.onHideAddTokensBox}
        onDone={this.handleDeviceChanged}
      />;
    }

    return <Fragment />;
  }



  _renderTargetingPicker() {
    let {targetType, isValid, options, selected } = this.props.context.currentMessage.targeting;
    let el;

    switch(targetType.label) {
      case 'All Customers':
        // Selecting "All Customers" from the dropdown is the entire interaction —
        // handleAllChanged sets targetType.label = 'All Customers' + isValid = true,
        // which is what the send pipeline reads. No UI is needed in the append area.
        el = null;
        break;

      case 'App':
        el = <Typeahead
          id="targeting"
          clearButton
          selected={selected}
          multiple
          options={options}
          isInvalid={!isValid}
          placeholder={targetType.placeholder}
          renderMenu={this._renderMenu}
          onChange={this.handleAppChanged}
          onInputChange={this.handleInputChange}
        />;
        break;

      case 'Topic':
        el = <InputGroup.Text>
          <Container onClick={this.showTopicPicker}>
            <Row>
              <TopicTreeView
                rootTopic={this.props.context.rootTopic}
                onToggleOff={this.handleOnToggleOffTopic}
              />
            </Row>
          </Container>
        </InputGroup.Text>;
        break;

      case 'Device':
        el = (
          <DeviceTokensList
            tokens={_compact(selected)}
            onDeleteToken={this.onDeleteToken}
            onShowAddBox={this.showAddTokensBox}
          />
        );
        break;

      default:
        el = <InputGroup.Text>Please select a target first</InputGroup.Text>;
    }

    return el;
  }

}

export default withContext(Targeting);
